export default __webpack_public_path__ + "static/media/473.c34ff471.png";